import React, { useEffect } from 'react';
import {
  ChakraProvider,
  Box,
  Text,
  VStack,
  Code,
  Grid,
  theme,
} from '@chakra-ui/react';
import { ColorModeSwitcher } from './ColorModeSwitcher';
import { Logo } from './Logo';
import { TopServices } from './components/TopServices';
import { Routes, Route, Outlet, Link } from 'react-router-dom';
import { SingleService } from './components/SingleService';
import NavBar from './components/NavBar';
import { transformData, createNestedCategories } from './util.js';
import { CategoryServices } from './components/CategoryServices';
import { UserPage } from './components/UserPage';
import { NewService } from './components/NewService';
import { OrderPage } from './components/OrderPage';
import { cans, waitCanisters, isLogged, login, logout } from './icblast.js';
import RegistrationModal from './components/UserRegister.js';
function App() {
  // I didn't want to use proper state management to keep things easy to understand
  // that always backfires
  let [categories, setCategories] = React.useState([]);
  let [loading, setLoading] = React.useState(true);
  let [logged, setLogged] = React.useState(false);
  let [user, setUser] = React.useState(false);
  let [register, setRegister] = React.useState(false);

  const doLogout = () => {
    logout().then(setLogged(false));
    setRegister(false);
  };
  const onRegistered = () => {
    setRegister(false);
  };

  useEffect(() => {
    if (loading) waitCanisters().then(() => setLoading(false));
    else
      (async () => {
        let x = await cans.qgig.get_categories();

        let r = createNestedCategories(x);
        setCategories(r);
      })();
  }, [loading]);

  useEffect(() => {
    if (!loading && logged && !user) {
      if (!cans.qgig.$logged) console.log('PROB');
      cans.qgig
        .get_my_info()
        .then(setUser)
        .catch(e => {
          console.log('get_my_info', e);
          setRegister(true);
          console.log('Lets register the identity');
        });
    }
  }, [loading, logged, user, register]);

  useEffect(() => {
    setTimeout(async () => {
      if (isLogged()) {
        await login();
        setLogged(isLogged());
      }
    }, 500);
  }, []);
  console.log(user);
  if (loading) return null;
  return (
    <ChakraProvider theme={theme}>
      <NavBar
        categories={categories}
        logged={logged}
        setLogged={setLogged}
        user={user}
        doLogout={doLogout}
      />
      {register ? (
        <RegistrationModal onClose={doLogout} onRegistered={onRegistered} />
      ) : null}
      <Box textAlign="center" fontSize="xl" mt="1vh" pb="30vh">
        <Routes>
          <Route index element={<TopServices logged={logged} />} />
          <Route
            path="/category/:id"
            element={<CategoryServices logged={logged} />}
          />
          <Route path="/user/:id" element={<UserPage logged={logged} />} />
          <Route path="/order/:id" element={<OrderPage logged={logged} />} />
          <Route path="/new_service" element={<NewService logged={logged} />} />

          <Route
            path="/service/:id"
            element={<SingleService categories={categories} logged={logged} />}
          />
        </Routes>
      </Box>
    </ChakraProvider>
  );
}

export default App;
